import React from "react";
import { Col, Row, Form } from "reactstrap";
import "../../../../CompletedAssessment/Invite-Respondants-Modal/invite-respondants-modal.css";
import Renderinputfields from "./inputFields";
import ResponsiveInputFields from "./Responsive/InputField";
import info from "../../../../../../images/info_black_24dp.png";

const Renderinviterespondantsmodal = (props) => {
  const calcWidth = window.innerWidth;

  return (
    <Form onSubmit={props.handleModalFormSubmit}>
      <div
        style={{
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          display: "flex",
          padding: "10px",
          borderRadius: "5px",
          marginRight: "20%",
          fontSize: "14px",
        }}
      >
        <img
          src={info}
          alt="Information Icon"
          style={{
            width: "20px",
            height: "20px",
            marginRight: "8px",
          }}
        />
        <div style={{ display: "inline-block", verticalAlign: "middle" }}>
          Invite at least one Business partner.
        </div>
      </div>

      <Row form>
        <Col>
          <p className="form-label">email id</p>
        </Col>
        <Col>
          <p className="form-label">relationship</p>
        </Col>
      </Row>
      <Row form>
        {calcWidth <= 767 ? (
          <ResponsiveInputFields
            inputFields={props.inputFields}
            handleInputFields={props.handleInputFields}
            handleRelationDropdown={props.handleRelationDropdown}
            dropDownOptions={props.dropDownOptions}
            handleInvitationsEmail={props.handleInvitationsEmail}
            isChecked={props.isChecked}
            isDisabled={props.isDisabled}
            handleModalSubmit={props.handleModalSubmit}
            handleModalClose={props.handleModalClose}
          />
        ) : (
          <Renderinputfields
            inputFields={props.inputFields}
            handleInputFields={props.handleInputFields}
            handleRelationDropdown={props.handleRelationDropdown}
            dropDownOptions={props.dropDownOptions}
            handleInvitationsEmail={props.handleInvitationsEmail}
            isChecked={props.isChecked}
            isDisabled={props.isDisabled}
            handleModalSubmit={props.handleModalSubmit}
            handleModalClose={props.handleModalClose}
          />
        )}
      </Row>
    </Form>
  );
};
export default Renderinviterespondantsmodal;



// WEBPACK FOOTER //
// ./src/new/Components/Invitations/Sent/Invitation-Modal/Invite-respondants-modal/index.jsx